import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const IncreaseBuildingUsagesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.INCREASE_BUILDING_USAGES>();

    const value = values.increaseBuildingUsages.value;
    const selection = Object.keys(value)
        .filter((key) => value[key as keyof typeof value])
        .sort()
        .join("#");

    return (
        <Fragment>
            <div className={classes.container}>
                <div>
                    <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 24 }}>
                        Gebäudenutzung
                    </h4>
                    <p className={classes.p} style={{ marginBottom: 0 }}>
                        Bitte geben Sie die Gebäudenutzung am zuvor beantragten oder bereits bestehenden Netzanschluss  an.
                    </p>
                </div>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues((values) => {
                                values.increaseBuildingUsages.value = {
                                    business: v.indexOf("business") >= 0,
                                    household: v.indexOf("household") >= 0,
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            value="household"
                            control={<Radio />}
                            label="Haushalt"
                            text="Wohnhaus mit einer oder mehreren Wohneinheit/en"
                            error={values.increaseBuildingUsages.error != null}
                        />
                        <FormControlLabel
                            value="business"
                            control={<Radio />}
                            label="Gewerbe"
                            text="Gewerbe, öffentliche Ladesäulen, Landwirtschaft, öffentliche Einrichtungen, Werbeflächen, Tele- oder Wasserversorgung etc."
                            error={values.increaseBuildingUsages.error != null}
                        />
                        <FormControlLabel
                            value="business#household"
                            control={<Radio />}
                            label="Haushalt und Gewerbe"
                            text="Gewerbe mit Wohneinheiten"
                            error={values.increaseBuildingUsages.error != null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
